const types = Object.freeze({
  New: 1,
  Used: 2,
  Auction: 3,
});

const options = Object.freeze([
  {
    id: types.New,
    name: 'Nuevo',
  },
  {
    id: types.Used,
    name: 'Usado',
  },
  {
    id: types.Auction,
    name: 'Subasta',
  },
]);
export { options };
export default types;
